import React from 'react';
import './style.scss';

export const Burger = ({ className, isOpen, ...props }: any) => (
  <button
    className={`hamburger hamburger--squeeze ${className}`}
    aria-label="menu"
    aria-haspopup="true"
    aria-controls="main_menu"
    aria-expanded={isOpen}
    {...props}
  >
    <span className="hamburger-box">
      <span className="hamburger-inner"></span>
    </span>
  </button>
);
